import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getCallTypes } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchCallTypes(): Promise<APIResult> {
  const response = await fetch(getCallTypes, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  IsSuccess: boolean;
  StatusCode: number;
  Data: Array<{
    Abbreviation: string;
    Description: string;
    Id: number;
    Priority: number;
  }>;
};

type TResult = Array<{
  id: number;
  name: string;
}>;

function useGetCallTypes(): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_call_types',
    async () => {
      const fetchResponse = await fetchCallTypes();
      const result = fetchResponse?.Data?.map(item => ({
        id: item.Id,
        name: item.Description,
      }));
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetCallTypes };
